import { Errors } from '../logger/Errors'
import { Log } from '../logger/Log'

export class InitialTokenFetchActivity {
  private start: number

  constructor() {
    this.start = Date.now()
  }

  public finishWithSuccess(authType: string | undefined, authResult: string): void  {
    Log.logger.logReportData('InitialTokenFetchActivity', false /* isCriticalEvent */, {
      'Success': true,
      'SuccessRate': 1,
      'Duration': Date.now() - this.start,
      'AuthType': authType ? authType : '',
      'AuthResult' : authResult,
    })
  }

  public finishWithFailure(authType: string | undefined, errorBucket: string, error?: Error): void {
    Log.logger.logReportData('InitialTokenFetchActivity', false /* isCriticalEvent */, {
      'Success': false,
      'SuccessRate': 0,
      'Duration': Date.now() - this.start,
    } /* payloadNonPII */, {
      'ErrorName': error ? error.name : '',
      'ErrorMessage': error ? error.message : '',
      'AuthResult' : errorBucket,
      'ErrorBucket': errorBucket,
      'AuthType': authType ? authType : '',
    })

    Log.logger.logUnexpected(Errors.getInitialTokenFetchError(errorBucket), errorBucket)
  }
}
